import Skeleton from 'react-loading-skeleton'

export default function LoadingSkeleton({height, count}:{height:number, count?: number}){
  return <Skeleton height={height} count={count} />
}
